export default "__VITE_ASSET__wAtGKec4__"